import { faRotate } from "@fortawesome/pro-regular-svg-icons/faRotate";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconUserRoleDynamic: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faRotate} />;
};
